export const IconEmail = ({ className }: { className?: string }) => (
  <svg
    className={className}
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    role="img"
    aria-label="email"
  >
    <g clipPath="url(#clip0_1067_401)">
      <path d="M13.9711 2.02891H2.02873C1.20769 2.02891 0.543398 2.70067 0.543398 3.52171L0.535934 12.4785C0.535934 13.2995 1.20769 13.9713 2.02873 13.9713H13.9711C14.7922 13.9713 15.4639 13.2995 15.4639 12.4785V3.52171C15.4639 2.70067 14.7922 2.02891 13.9711 2.02891ZM13.9711 12.4785H2.02873V5.01451L7.99993 8.74651L13.9711 5.01451V12.4785ZM7.99993 7.25371L2.02873 3.52171H13.9711L7.99993 7.25371Z" />
    </g>
    <defs>
      <clipPath id="clip0_1067_401">
        <rect width="16" height="16" />
      </clipPath>
    </defs>
  </svg>
)
